import React from 'react'

export default function Education() {
  return (
    <div  style={{padding : '5px', margin : '10px'}} >
        <h2 style={{textAlign : 'center'}} >Education</h2>
<div style={{display : 'flex' , justifyContent : 'space-evenly' , flexWrap : 'wrap'}} >
    <div style={{border : '1px solid black' , padding : '10px' , height : '130px'}} >
    <p style={{fontWeight : '530'}} >Maharaja Agrasen Institute Of Technology , Delhi</p>
        <p>B.Tech in Information Technology</p>
        <p>2021-2025</p>

    </div>

    <div style={{border : '1px solid black' , padding : '10px' , margin : '5px'}}  >

        <p style={{fontWeight : '530'}}  >AGDAV Centenary Public School , Delhi </p>
        <p>12th , Non-Med (Science) </p>
        <p>2021</p>
    </div>

</div>
     
    </div>
  )
}
